import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
//import Button from '@mui/material/Button';
import {Dataset} from './Inc';
import TwinInput from './TwinInput';
import useStyles from './Styles';
import BottomButtons from './BottomButtons';
import useMediaQuery from '@mui/material/useMediaQuery';
import {Theme} from './Theme';

interface ItemSpecSampleProps {
	isOpen:boolean,
	close():void,
}

interface ItemInputParams {
    links:Dataset[],
    specs:Dataset[],
    photo_ids:number[],
	//tax_per: number,
	tags:string[],
}

const ItemSpecSample = (props:ItemSpecSampleProps)=> {
	const classes = useStyles();
	const fullScreen = useMediaQuery(Theme.breakpoints.down('sm'));
    const changeParamTwin = (id:keyof ItemInputParams,index:number,value1:string,value2:string)=>{

    }

	return (
		<Dialog
			fullScreen={fullScreen}
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
			maxWidth="sm"
			disableEscapeKeyDown={true}
			onClose={(event: object, reason: string) =>{
				if( reason!=="backdropClick" ){
					props.close();
				}
			}}
		>
			<DialogTitle color='primary'>仕様の入力例</DialogTitle>
			<DialogContent dividers>
				<TwinInput value1="サイズ" value2="100 x 130 x 30mm" name1="仕様1" name2="仕様1の内容" maxLength1={10} maxLength2={100} placeholder1="サイズ、重さ、色など" placeholder2="A6、300g、赤など" error={true} change={changeParamTwin} id="specs" index={0} row/>
				<TwinInput value1="素材" value2="紙粘土、パテ、エナメルカラー" name1="仕様2" name2="仕様2の内容" maxLength1={10} maxLength2={100} placeholder1="サイズ、重さ、色など" placeholder2="A6、300g、赤など" error={true} change={changeParamTwin} id="specs" index={1} row/>
				<TwinInput value1="色" value2="銀、青灰、ワインレッド" name1="仕様3" name2="仕様3の内容" maxLength1={10} maxLength2={100} placeholder1="サイズ、重さ、色など" placeholder2="A6、300g、赤など" error={true} change={changeParamTwin} id="specs" index={2} row/>
				<TwinInput value1="製法" value2="オンデマンド印刷" name1="仕様4" name2="仕様4の内容" maxLength1={10} maxLength2={100} placeholder1="サイズ、重さ、色など" placeholder2="A6、300g、赤など" error={true} change={changeParamTwin} id="specs" index={3} row/>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<BottomButtons button1='閉じる' onClick1={props.close} top={0} bottom={0}/>
			</DialogActions>
		</Dialog>
	);
}

export default ItemSpecSample;
